module.exports = __webpack_public_path__ + "img/fullStar.d827f268.svg";